export const SK = 'sk';
export const HU = 'hu';